import React from "react";
import { Form, Row, Col } from "antd";
import ControlledInput from "../../components/Backoffice/ControlledInput";
import ControlledSelect from "../../components/Backoffice/ControlledSelect";
import ControlledFileInput from "../../components/Backoffice/ControlledFileInput";
import FormSection from "../../components/Backoffice/FormSection";
import {
  getCountryOptions,
  getStateOptions,
  getCityOptions,
} from "../../utils/form";
const isKeycloakEnabled = process.env.REACT_APP_ENABLE_KEYCLOAK === 'true';

const AddLabForm = ({
  options = {},
  control,
  watch,
  errors,
  edit = false,
  setValue,
}) => {
  const { states = [], cities = [], countries = [] } = options;

  const contract = watch("contract");
  const testingScope = watch("testingScope");

  return (
    <Form colon={false}>
      <FormSection heading="Basic Information">
        <Row gutter={24}>
          <Col span={12}>
            <ControlledInput
              required
              control={control}
              name="name"
              label="Registered Name"
              errors={errors}
            />
          </Col>
        </Row>
      </FormSection>
      <FormSection heading="Lab Address">
        <Row gutter={24}>
          <Col span={12}>
            <ControlledInput
              required
              control={control}
              name="address.addressLine1"
              label="Address Line 1"
              errors={errors}
            />
          </Col>
          <Col span={12}>
            <ControlledInput
              control={control}
              name="address.addressLine2"
              label="Address Line 2"
              errors={errors}
            />
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <ControlledSelect
              required
              control={control}
              name="address.country"
              label="Country"
              options={getCountryOptions(countries)}
              customChange={() => {
                setValue("address.state", "");
                setValue("address.city", "");
              }}
              errors={errors}
            />
          </Col>
          <Col span={12}>
            <ControlledSelect
              required
              control={control}
              name="address.state"
              label="State"
              options={getStateOptions(states)}
              customChange={() => {
                setValue("address.city", "");
              }}
              errors={errors}
            />
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <ControlledSelect
              required
              control={control}
              name="address.city"
              label="City"
              options={getCityOptions(cities)}
              errors={errors}
            />
          </Col>
          <Col span={12}>
            <ControlledInput
              required
              control={control}
              name="address.pincode"
              label="Pincode"
              errors={errors}
            />
          </Col>
        </Row>
      </FormSection>
      <FormSection heading="Point of Contact">
        <Row gutter={24}>
          <Col span={12}>
            <ControlledInput
              required
              control={control}
              name="user.firstName"
              label="First Name"
              errors={errors}
            />
          </Col>
          <Col span={12}>
            <ControlledInput
              control={control}
              name="user.lastName"
              label="Last Name"
              errors={errors}
            />
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <ControlledInput
              required
              control={control}
              name="user.email"
              label="Email"
              errors={errors}
              disabled={edit}
            />
          </Col>
          <Col span={12}>
            <ControlledInput
              required
              control={control}
              name="user.phone"
              label="Phone"
              errors={errors}
              disabled={edit}
            />
          </Col>
        </Row>
        {!edit && !isKeycloakEnabled && (
          <Row gutter={24}>
            <Col span={12}>
              <ControlledInput
                required
                control={control}
                name="user.password"
                label="Password"
                errors={errors}
              />
            </Col>
          </Row>
        )}
      </FormSection>
      <FormSection heading="Operations">
        <Row gutter={24}>
          <Col span={12}>
            <ControlledSelect
              required
              multiple
              control={control}
              name="operatingStates"
              label="Operating States"
              options={getStateOptions(states)}
              errors={errors}
            />
          </Col>
        </Row>
        {!edit && (
          <Row gutter={24}>
            <Col span={12}>
              <ControlledFileInput
                control={control}
                name="contract"
                label="Upload Contract"
                nameOfFile={contract}
                errors={errors}
              />
            </Col>
            <Col span={12}>
              <ControlledFileInput
                control={control}
                name="testingScope"
                label="Upload Testing Scope"
                nameOfFile={testingScope}
                errors={errors}
              />
            </Col>
          </Row>
        )}
      </FormSection>
    </Form>
  );
};

export default AddLabForm;
